module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/svg-icons/NoResults/default-e0259ef38c390fd82011429c5bff6fc8.svg";